export const traceabilityFr = {
  title: 'Généalogie et traçabilité des lots',
  subtitle:
    'Tracer les lots consommés et produits à tous les niveaux et évaluer les impacts d’un rappel.',
  help: { open: 'Ouvrir l’aide sur la généalogie des lots et les simulations de rappel' },
  tabs: { trace: 'Tracer les lots', simulations: 'Simulations de rappel' },
  filters: {
    title: 'Filtres de traçabilité',
    description:
      'Sélectionnez au moins un lot, un article, un partenaire ou un ordre de production. Tous les filtres sont limités au mandant.',
    batch: 'Lot',
    batchNumber: 'Le numéro de lot contient',
    product: 'Article',
    supplier: 'Fournisseur',
    customer: 'Client',
    productionOrder: 'Ordre de production',
    from: 'Réception à partir du',
    to: 'Réception jusqu’au',
    direction: 'Direction',
    depth: 'Niveaux maximum',
    any: 'Tous',
  },
  directions: {
    FORWARD: 'En avant vers les produits finis',
    BACKWARD: 'En arrière vers les matières premières',
    BOTH: 'Dans les deux sens',
  },
  relations: {
    ANCHOR: 'Lot de départ',
    UPSTREAM: 'Matière en amont',
    DOWNSTREAM: 'Produit en aval',
    BOTH: 'Relié dans les deux sens',
  },
  batchStatuses: {
    FREE: 'Libéré',
    QUARANTINE: 'Quarantaine',
    BLOCKED: 'Bloqué',
    EXPIRED: 'Expiré',
    DEPLETED: 'Épuisé',
  },
  actions: {
    calculate: 'Lancer la traçabilité',
    reset: 'Réinitialiser les filtres',
    createSimulation: 'Créer une simulation de rappel',
    review: 'Vérifier',
    cancel: 'Annuler',
    confirmBlocks: 'Bloquer les lots concernés',
    export: 'Exporter en CSV',
  },
  messages: {
    invalidFilter: 'Les filtres de traçabilité sont incomplets.',
    simulationCreated: 'Simulation créée à partir d’un instantané immuable.',
    review: 'Simulation de rappel vérifiée.',
    cancel: 'Simulation de rappel annulée.',
    blocksConfirmed: 'Les lots concernés encore en stock ont été bloqués.',
  },
  warnings: {
    truncatedTitle: 'Limite de résultat atteinte',
    truncated:
      'Le graphe a été tronqué à la profondeur choisie ou à la limite de sécurité. Affinez les filtres ou augmentez la profondeur.',
  },
  stats: {
    lots: 'Lots concernés',
    productionOrders: 'Ordres de production',
    deliveries: 'Livraisons',
    customers: 'Clients',
  },
  graph: {
    title: 'Flux matière multiniveau',
    description: 'Les flèches suivent le flux des lots consommés vers les lots produits.',
    ariaLabel: 'Graphe des lots en amont et en aval',
    snapshotTitle: 'Instantané de généalogie figé',
    snapshotDescription:
      'Ce graphe correspond exactement à la preuve enregistrée lors de la création de la simulation.',
  },
  impact: {
    title: 'Stocks, documents et partenaires concernés',
    description: 'L’impact est calculé à partir de l’ensemble complet des lots tracés.',
    inventory: 'Stock disponible',
    documents: 'Documents et livraisons',
    partners: 'Partenaires',
    productionOrders: 'Ordres de production',
    suppliers: 'Fournisseurs',
    customers: 'Clients',
    snapshotTitle: 'Analyse d’impact figée',
  },
  columns: {
    article: 'Article',
    batch: 'Lot',
    relation: 'Relation',
    status: 'Statut',
    warehouse: 'Entrepôt / emplacement',
    available: 'Disponible',
    document: 'Document',
    type: 'Type',
    customer: 'Client',
    date: 'Date',
    batches: 'Lots',
    productionOrder: 'Ordre de production',
    product: 'Produit',
    completed: 'Terminé',
  },
  empty: {
    inventory: 'Aucun stock concerné.',
    documents: 'Aucun document concerné.',
    partners: 'Aucun partenaire concerné.',
    orders: 'Aucun ordre de production concerné.',
    trace: 'Choisissez des filtres pour afficher la généalogie des lots.',
    simulations: 'Aucune simulation de rappel trouvée.',
    selectSimulation: 'Sélectionnez une simulation de rappel.',
  },
  simulations: {
    search: 'Rechercher numéro, titre ou motif',
    allStatuses: 'Tous les statuts',
    title: 'Simulations enregistrées',
    description: 'Chaque entrée conserve son graphe, son impact, ses filtres et sa preuve SHA-256.',
    noNotificationTitle: 'Aucune notification externe',
    noNotification:
      'Ce workflow n’informe ni clients, ni fournisseurs, ni autorités. Toute communication externe nécessite une action distincte, explicite et autorisée.',
  },
  statuses: {
    DRAFT: 'Brouillon',
    REVIEWED: 'Vérifiée',
    BLOCKS_CONFIRMED: 'Lots bloqués',
    CANCELLED: 'Annulée',
  },
  fields: {
    title: 'Titre',
    reason: 'Motif',
    note: 'Note de décision',
    createdAt: 'Créée',
    direction: 'Direction de traçabilité',
    snapshotHash: 'SHA-256 de l’instantané',
    blockedBatches: 'Lots bloqués',
  },
  create: {
    title: 'Créer une simulation de rappel',
    description:
      'Le graphe et l’impact actuels sont figés dans un instantané immuable. Aucun lot n’est encore bloqué.',
  },
  workflow: {
    review: {
      title: 'Vérifier la simulation de rappel',
      description: 'Confirmez que l’impact figé a été vérifié au regard des preuves disponibles.',
    },
    cancel: {
      title: 'Annuler la simulation de rappel',
      description:
        'L’instantané reste disponible pour l’audit ; aucun lot concerné ne sera modifié.',
    },
  },
  block: {
    title: 'Bloquer explicitement les lots concernés',
    description:
      '{{count}} lot(s) concerné(s) encore en stock seront évalués et bloqués dans une transaction.',
    notificationTitle: 'La communication externe est exclue',
    notificationDescription:
      'Le blocage du stock n’envoie aucun e-mail, message ou avis réglementaire.',
    confirmLots: 'Je confirme explicitement le blocage de tous les lots concernés encore en stock.',
    confirmNoNotification:
      'Je comprends qu’aucune notification externe n’est envoyée par cette action.',
  },
} as const;
